export const blockIconsFileDriveFolderUpload = (
	<span className='material-symbols-outlined'>drive_folder_upload</span>
);
